









































import doughnutChart from '@/components/Argon/Charts/DoughnutChart';
import { dailyTotal, StatParams } from '@/store/interfaces/stats';
import Vue, { PropType } from 'vue';

type chartData = {
  datasets: { data: number[]; backgroundColor: string[] }[];
  labels: string[];
};
type tPercentageLabels = {
  class: string;
  icon: string;
  title: string;
  total: dailyTotal;
};

export default Vue.extend({
  name: 'CustomStatCardChart',
  components: {
    doughnutChart,
  },
  props: {
    title: {
      required: true,
      type: String,
    },
    percentageLabels: {
      required: true,
      type: Array as PropType<tPercentageLabels[]>,
    },
    total: {
      required: true,
      type: String,
    },
    stats: {
      required: true,
      type: Object as PropType<StatParams & Record<string, number>>,
    },
  },
  data: () => ({
    options: {
      legend: {
        display: false,
      },
      responsive: true,
      maintainAspectRatio: false,
    },
  }),
  methods: {
    calculatePercentage(total: number, value: number): number {
      const percentage = (100 * value) / total;
      return total === 0 ? 0 : Math.round(100 * percentage) / 100;
    },
    chartData(labels: tPercentageLabels[]): chartData {
      const dataPercentage: number[] = [];
      const chartLabels: string[] = [];
      labels.forEach((line, idx: number) => {
        dataPercentage[idx] = this.calculatePercentage(
          100,
          this.stats[line.total]
        );
        chartLabels[idx] = line.title;
      });
      return {
        datasets: [
          {
            data: dataPercentage,
            backgroundColor: ['#2dce89', '#fb6340', '#f5365c'],
          }
        ],
        labels: chartLabels,
      };
    },
  },
});
